export default {
	methods: {
		convertResolution (value) {

			const temp = value.split('x')
			const width = parseInt(temp[0])
			const height = parseInt(temp[1])

			if (width == 1920 && height == 1080) {
				return 'Landscape'
			}
			else if (width == 1080 && height == 1920) {
				return 'Portrait'
			}
			else {
				return `Custom (${width}x${height})`
			}

		},
		setTempResolution () {
			const temp = this.form.settings.resolution.split('x')
			const tempWidth = parseInt(temp[0])
			const tempHeight = parseInt(temp[1])

			if (tempWidth == 1920) {
				this.tempResolution.resolution = 'landscape'
				this.tempResolution.resolutionWidth = 1920
				this.tempResolution.resolutionHeight = 1080
			}
			else if (tempWidth == 1080) {
				this.tempResolution.resolution = 'portrait'
				this.tempResolution.resolutionWidth = 1080
				this.tempResolution.resolutionHeight = 1920
			}
			else {
				this.tempResolution.resolution = 'custom'
				this.tempResolution.resolutionWidth = tempWidth
				this.tempResolution.resolutionHeight = tempHeight
			}
		}
	}
}
